module.exports = __webpack_public_path__ + "img/vuejs-stencil.c68cbdbd.svg";